import {LetterFilters} from "./letter-filters";

export default {
    install (Vue) {
        Vue.filter('sentenceCase', LetterFilters.sentenceCase);
        Vue.filter('titleCase', LetterFilters.titleCase);
        Vue.filter('upperCase', LetterFilters.upperCase);
        Vue.filter('lowerCase', LetterFilters.lowerCase);
    }
}



// WEBPACK FOOTER //
// ./src/filters/index.js